import { useContext, createContext } from "react";
export const useThemeContext = () => useContext(ThemeContext);
export const ThemeContext = createContext({});
